import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    outlined?: boolean;
  }>()
  .create(({ theme, outlined }) => ({
    verticalBarChart: {
      width: '100%',
      alignItems: 'stretch',
      display: 'flex',
      height: '100%',
      maxHeight: '100%',
      overflow: 'hidden',
      border: outlined ? `2px solid ${theme.vars.palette.divider}` : 'none',
      borderRadius: '4px',
      paddingBottom: outlined ? '0.75rem' : '0'
    }
  }));

export default useStyles;
